/**
 * Admin Invitation Code Management Service
 * API: /api/admin/invitation-codes
 */

import client from '@lib/core/axios.client';
import { API_ENDPOINTS } from '@lib/constants';
import type {
  AdminInvitationCodeListParams,
  AdminInvitationCodeListResponse,
  CreateInvitationCodeCommand,
  DeactivateInvitationCodeResponse,
  InvitationCodeReportParams,
  InvitationCodeReportResponse,
  InvitationCodeDto,
} from '@/types/api/admin';

export class AdminInvitationCodeService {
  private static instance: AdminInvitationCodeService;

  private constructor() {}

  public static getInstance(): AdminInvitationCodeService {
    if (!AdminInvitationCodeService.instance) {
      AdminInvitationCodeService.instance = new AdminInvitationCodeService();
    }
    return AdminInvitationCodeService.instance;
  }

  /**
   * Get list of all invitation codes with pagination and filters
   */
  async getAllInvitationCodes(
    params?: AdminInvitationCodeListParams
  ): Promise<AdminInvitationCodeListResponse> {
    return await client.get<AdminInvitationCodeListResponse>(
      API_ENDPOINTS.ADMIN.INVITATION_CODES.LIST,
      { params }
    );
  }

  /**
   * Create new invitation code (admin)
   */
  async createInvitationCode(data: CreateInvitationCodeCommand): Promise<InvitationCodeDto> {
    return await client.post<InvitationCodeDto>(
      API_ENDPOINTS.ADMIN.INVITATION_CODES.CREATE,
      data
    );
  }

  /**
   * Deactivate invitation code
   */
  async deactivateInvitationCode(id: string): Promise<DeactivateInvitationCodeResponse> {
    return await client.put<DeactivateInvitationCodeResponse>(
      API_ENDPOINTS.ADMIN.INVITATION_CODES.DEACTIVATE(id)
    );
  }

  /**
   * Get invitation code usage report
   */
  async getInvitationCodeReport(
    params?: InvitationCodeReportParams
  ): Promise<InvitationCodeReportResponse> {
    return await client.get<InvitationCodeReportResponse>(
      API_ENDPOINTS.ADMIN.INVITATION_CODES.REPORT,
      { params }
    );
  }
}

export const adminInvitationCodeService = AdminInvitationCodeService.getInstance();
